/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Joininformation1Inputs */

const de__field_joininformation1 = /** @type {(inputs: _Field_Joininformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrittsinformationen`)
};

/**

* @param {_Field_Joininformation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_joininformation1 = /** @type {((inputs?: _Field_Joininformation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Joininformation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_joininformation1(inputs)
});
export { _field_joininformation1 as "_field_joinInformation" }